import { EventHandler, NumberRange, EZoomState, } from "scichart";
function toNumberRange(range) {
    const [from, to] = range;
    return new NumberRange(from.getTime() / 1000, to.getTime() / 1000);
}
function fromNumberRange(range) {
    const { min, max } = range;
    return [
        new Date(min * 1000),
        new Date(max * 1000),
    ];
}
function setAxisRange(axis, range) {
    const surface = axis.parentSurface;
    axis.visibleRange = range;
    if (surface && surface.zoomState === EZoomState.AtExtents) {
        axis.zoomExtentsRange = range;
    }
}
function debounce(callback, wait) {
    let timeoutId = null;
    return (...args) => {
        timeoutId && clearTimeout(timeoutId);
        timeoutId = window.setTimeout(() => {
            callback(...args);
        }, wait);
    };
}
export class AxisSynchronizer {
    constructor(range) {
        this.visibleRange = new NumberRange();
        this.visibleRangeChanged = new EventHandler();
        this.reformatYAxis = new EventHandler();
        this.axes = [];
        this.publishChange = (data) => {
            const range = data === null || data === void 0 ? void 0 : data.visibleRange;
            if (range && range !== this.visibleRange) {
                this.visibleRange = range;
                for (const axis of this.axes) {
                    setAxisRange(axis, range);
                }
                this.onChange();
            }
        };
        this.visibleRange = toNumberRange(range);
        this.onChange = debounce(() => {
            this.visibleRangeChanged.raiseEvent(fromNumberRange(this.visibleRange));
        }, 500);
    }
    changeRange(range) {
        const newRange = toNumberRange(range);
        this.visibleRange = newRange;
        for (const axis of this.axes) {
            setAxisRange(axis, newRange);
        }
    }
    addAxis(axis) {
        if (!this.axes.includes(axis)) {
            this.axes.push(axis);
            setAxisRange(axis, this.visibleRange);
            axis.visibleRangeChanged.subscribe(this.publishChange);
        }
    }
    removeAxis(axis) {
        const index = this.axes.findIndex((a) => a === axis);
        if (index >= 0) {
            this.axes.splice(index, 1);
            axis.visibleRangeChanged.unsubscribe(this.publishChange);
        }
    }
}
//# sourceMappingURL=AxisSynchronizer.js.map